import { getCloudfrontUrl } from './cloudfront-utils';
export function getImageKitUrl(value, ...args) {
    const url = new URL(value);
    const path = url.pathname;
    if (path.includes('/asset-snapshot')) {
        return path.slice(15, path.length);
    }
    return path;
}
export function getImageKitUrlForTemplatePreviewThumbnail(thumbnailURL) {
    const thumbnailUrl = thumbnailURL;
    const cloudFrontUrl = getCloudfrontUrl(thumbnailUrl);
    const imageKitUrl = getImageKitUrl(cloudFrontUrl);
    return imageKitUrl;
}
